@if (isOfflineCache()) {
  <span>
    <ng-container *ngTemplateOutlet="downloadTemplate"> </ng-container>
  </span>
}
@if (!isOfflineCache()) {
  <span>
    @switch (simpleType()) {
      <!-- START ATTACHMENT visuals -->
      @case ('image') {
        @if (clickToLoadImage()) {
          <div class="flex flex-col text-base p-4">
            <div class="text-color italic mb-1">
              {{ 'cl_chat.imageSharedIsABitLarge' | translate }}
            </div>
            <button
              [attr.tabindex]="currentTabIndex()"
              class="w-fit flex flex-row items-center border-0 bg-transparent text-primary p-0 cursor-pointer"
              (click)="expandImage($event)"
            >
              @if (!clickToLoadImageExpanded()) {
                <div data-e2e="click-to-expand">
                  {{ 'cl_chat.clickToExpand' | translate }}
                  ({{ attachmentSize() }})
                </div>
              }
              @if (clickToLoadImageExpanded()) {
                <div data-e2e="click-to-collapse">
                  {{ 'cl_chat.clickToCollapse' | translate }}
                  ({{ attachmentSize() }})
                </div>
              }
              <i class="mi2-arrow-down text-[14px] ml-2" [ngClass]="{ 'rotate-180': clickToLoadImageExpanded() }"></i>
            </button>
            @if (clickToLoadImage() && clickToLoadImageLoaded() && !imageViewerUrl()) {
              <div class="mt-2 text-color">
                {{ 'cl_chat.loading' | translate }}
              </div>
            }
          </div>
        }
        @if (!clickToLoadImage() || clickToLoadImageExpanded()) {
          <div #attachmentImage class="image-message" [ngClass]="{ '!cursor-default': previewMode() }">
            @if (imageViewerUrl()) {
              <img
                class="rounded-b-2xl"
                [ngClass]="{ '!cursor-default': previewMode() }"
                [attr.tabindex]="currentTabIndex()"
                (keydown.enter)="fullScreenImage()"
                (click)="fullScreenImage()"
                [src]="imageViewerUrl()"
                [attr.data-image-name]="attachmentName()"
                [attr.aria-label]="'cl_chat.fileLabels.image' | translate: { fileName: attachmentName() }"
              />
            }
          </div>
        }
      }
      @case ('video') {
        <app-video-card
          [attachmentName]="attachmentName()"
          [attachmentSize]="attachmentSize()"
          [conversationId]="item()?.conversationId"
          [attachmentId]="item()?.body"
          [currentTabIndex]="currentTabIndex()"
          [attr.aria-label]="'cl_chat.fileLabels.video' | translate: { fileName: attachmentName() }"
          [previewMode]="previewMode()"
        >
        </app-video-card>
      }
      @case ('audio') {
        <app-audio-card
          [previewMode]="previewMode()"
          [isVoicemail]="false"
          [item]="item()"
          [currentTabIndex]="currentTabIndex()"
          [attachmentName]="attachmentName()"
          [attachmentSize]="attachmentSize()"
          [blobUrl]="blobUrl()"
          [isOffline]="isOffline()"
          [isMobile]="isMobile()"
          [attr.aria-label]="'cl_chat.fileLabels.audio' | translate: { fileName: attachmentName() }"
          (onDownloadAttachmentClicked)="downloadAttachment()"
        >
        </app-audio-card>
      }
      @default {
        <ng-container *ngTemplateOutlet="downloadTemplate"> </ng-container>
      }
      <!-- END ATTACHMENT visuals -->
    }
  </span>
}

<ng-template #downloadTemplate>
  <button
    class="flex items-center justify-start text-left no-underline cursor-pointer border-0 bg-transparent p-0 group focus-visible:outline-none"
    [ngClass]="{ '!cursor-default': previewMode() }"
    (click)="!isOffline() && !hasHtmlAnchorContent() ? downloadAttachment() : ''"
    [attr.tabindex]="currentTabIndex()"
  >
    <mi-attachment-icon [attachmentName]="item()?.clCompChat_displayBody"> </mi-attachment-icon>
    <div
      #attachmentNameEl
      [pTooltip]="attachmentNameEl.scrollWidth > attachmentNameEl.clientWidth ? attachmentName() : ''"
      tooltipPosition="top"
      class="font-bold inline-block text-base text-color ml-3 mr-5.5 break-words w-[143px] ellipsis-overflow"
      [ngClass]="{ 'my-content': isMine() }"
      data-e2e="download-text"
    >
      @if (hasHtmlAnchorContent()) {
        <span [innerHTML]="attachmentName()"></span>
      } @else {
        {{ attachmentName() }}
      }
      <div
        class="h-[22px] pt-[5px] text-sm text-color font-semibold"
        [ngClass]="{
          'my-content': isMine(),
          'block': !previewMode(),
          'group-hover:hidden': !hasHtmlAnchorContent(),
          'group-focus-within:hidden': !hasHtmlAnchorContent()
        }"
      >
        {{ 'cl_chat.fileSize' | translate }}: {{ attachmentSize() }}
      </div>
      @if (!previewMode() && !hasHtmlAnchorContent()) {
        <div
          class="pt-[5px] hidden h-[22px] text-sm text-primary w-max group-hover:block group-focus-within:block group-focus-visible:[&>*]:shadow-[0_0_0_1px_var(--p-primary-color)] group-focus-visible:[&>*]:rounded-[2px]"
          [ngClass]="{ 'my-content': isMine() }"
        >
          <i class="mi2-download text-sm"></i>
          <span>
            {{ 'cl_chat.clickToDownload' | translate }}
          </span>
        </div>
      }
    </div>
  </button>
</ng-template>
